import { Button } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useDataProvider, useNotify, useRefresh, useUnselectAll } from "react-admin";
import ConfirmModal from "server/components/Modals/ConfirmModal";

const ApproveConfirmModal = ({ stage, ids, resource, triggerLabel, iconOnly = false }) => {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();
  const unselectAll = useUnselectAll(resource);

  const handleConfirm = async () => {
    await dataProvider.customRequest(stage.approveUrl, { ids }, "POST");
    notify(`Одобрени записи: ${ids.length}`, { type: "success" });
    refresh();
    unselectAll();
  };

  return (
    <ConfirmModal
      titleContent="Одобрение"
      saveTitle="Одобри"
      onConfirm={handleConfirm}
      message={`Сигурни ли сте, че искате да одобрите ${ids.length} ${ids.length === 1 ? "запис" : "записа"}?`}
      triggerButton={
        <Button
          variant={iconOnly ? "text" : "contained"}
          color="success"
          size="small"
          disabled={!ids?.length}
          startIcon={<CheckCircleIcon />}
        >
          {iconOnly ? "" : triggerLabel}
        </Button>
      }
    />
  );
};

export default ApproveConfirmModal;
